/**
 * Escapes a string so that captions/alt text cannot inject HTML into the page.
 */
export const escapeHtml = (value: unknown): string => {
  if (typeof value !== "string" || value.length === 0) {
    return "";
  }

  return value
    .split("&")
    .join("&amp;")
    .split("<")
    .join("&lt;")
    .split(">")
    .join("&gt;")
    .split('"')
    .join("&quot;")
    .split("'")
    .join("&#039;");
};

/**
 * Only allow http(s) URLs or Storyblok-relative asset paths.
 * Rejects anything else to avoid XSS or protocol abuse.
 */
export const sanitizeUrl = (value: unknown): string => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();

  if (!trimmed) return "";

  if (/^(https?:)?\/\//.test(trimmed) || trimmed.startsWith("/")) {
    return trimmed.split('"').join("%22");
  }

  return "";
};
